import React, { Component } from "react";
import { Link } from "react-router-dom";

import axios from "axios";
import "./Search.css";

import { Results } from "../../components/results/Results";
import { CustomFilter } from "../../components/customfilter/CustomFilter";
import { useLanguage } from "../../contexts/LanguageContext";
import { useTranslation } from "../../hooks/useTranslation";
import apiWithLanguage from "../../util/apiWithLanguage";
import withDataTranslation from "../../util/withDataTranslation";
import SEOHead from "../../components/seo/SEOHead";

import Util from "../../util/util";

class Search extends Component {
  constructor(ttt) {
    super();
    this.state = {
      itemsList: [],
      topStores: [],
      promoted_products: [],
      filter: [],
      filterCheck: [],
      filterSearch: [],
      oneOption: [],
      mainCategory: 0,
      lastSearch: window.location.search,
      lastQuery: "",
      sortValue: "Najsličniji",
      firstRun: true,
      enteredMobile: false,
      dropFilters: true,
      sortMenuOpen: false,
      loadingSearch: false,
      allCategories: [],
      recentProducts: [],
      broaderProducts: [],
      popularProducts: [],
    };
  }

  getCategoryPath = () => {
    var languages = ["ba", "en", "fr", "es", "it", "ru", "ar", "de", "pt", "tr", "zh", "hi", "ur"];
    var segments = window.location.pathname.split("/").filter(Boolean);
    if (languages.includes(segments[0])) {
      segments = segments.slice(1);
    }

    return {
      nowPath0: segments[0],
      nowPath: segments[0] == "k" ? segments[1] : "",
      nowPath2: segments[0] == "k" ? (segments[2] || "") : "",
    };
  };

  componentDidUpdate() {
    var categoryPath = this.getCategoryPath();
    if (this.state.lastSearch !== window.location.search && !categoryPath.nowPath) {
      this.setState(
        { filter: [], filterCheck: [], lastSearch: window.location.search },
        () => {
          this.refreshPageSearch();
        }
      );
    }
  }

  componentDidMount() {
    document.title = this.props.pageTitle;
    // Set language for API calls
    if (this.props.currentLanguage) {
      apiWithLanguage.setLanguage(this.props.currentLanguage);
    }
    this.refreshPageSearch();
    this.loadLandingLists();

    if (window.matchMedia("only screen and (max-width: 768px)").matches) {
      this.setState({ enteredMobile: true, dropFilters: true });
    }
  }

  cleanSeoText = (text) => {
    if (!text) {
      return "";
    }

    return decodeURI(String(text))
      .replace(/-/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  };

  path = (path) => {
    return this.props.getPathWithLanguage ? this.props.getPathWithLanguage(path, this.props.currentLanguage) : path;
  };

  t = (text) => {
    return this.props.dataTranslation ? this.props.dataTranslation.translateUI(text) : text;
  };

  loadLandingLists = () => {
    var mainThis = this;

    axios
      .post(window.ajaxLink + "products/categories", {})
      .then((res) => {
        if (
          res["data"] &&
          res["data"]["responseData"] &&
          res["data"]["responseData"]["categories"]
        ) {
          mainThis.setState({
            allCategories: res["data"]["responseData"]["categories"],
          });
        }
      })
      .catch((err) => {});

    axios
      .post(window.ajaxLink + "products/recent", { limit: 30, random: 1 })
      .then((res) => {
        var recentProducts =
          res["data"] &&
          res["data"]["responseData"] &&
          res["data"]["responseData"]["products"]
            ? res["data"]["responseData"]["products"]
            : [];

        mainThis.setState({ recentProducts: recentProducts });
      })
      .catch((err) => {});
  };

  loadBroaderCategoryProducts = (category) => {
    if (!category) {
      return;
    }

    apiWithLanguage
      .getCategoryData({
        category: decodeURI(category),
        filter: "",
        customFilter: [],
        mainCategory: 0,
        oldFilters: [[], []],
        sort_value: "Najnoviji",
      })
      .then((res) => {
        var products =
          res["data"] &&
          res["data"]["responseData"] &&
          res["data"]["responseData"]["products"]
            ? res["data"]["responseData"]["products"]
            : [];

        this.setState({ broaderProducts: products });
      })
      .catch((err) => {});
  };

  getFlattenedCategories = () => {
    var categories = [];

    for (var category of this.state.allCategories) {
      categories.push(category);
      if (category.sub_categories && category.sub_categories.length > 0) {
        for (var subCategory of category.sub_categories) {
          categories.push({
            ...subCategory,
            parent_link: category.link,
            parent_name: category.name,
          });
        }
      }
    }

    return categories;
  };

  getCategoryLandingLinks = () => {
    var categoryPath = this.getCategoryPath();
    var links = [];

    for (var category of this.state.allCategories) {
      if (category.link == "/k/" + categoryPath.nowPath) {
        links = category.sub_categories || [];
      }

      if (category.sub_categories && category.sub_categories.length > 0) {
        for (var subCategory of category.sub_categories) {
          if (subCategory.link == "/k/" + categoryPath.nowPath + "/" + categoryPath.nowPath2) {
            links = category.sub_categories.filter((oneItem) => {
              return oneItem.link !== subCategory.link;
            });
          }
        }
      }
    }

    return links.slice(0, 12);
  };

  getSearchCategoryLinks = () => {
    var query = (this.state.lastQuery || "").toLowerCase();
    var flattenedCategories = this.getFlattenedCategories();
    var matchedCategories = [];

    for (var category of flattenedCategories) {
      if (
        query &&
        category.name &&
        (category.name.toLowerCase().indexOf(query) > -1 ||
          query.indexOf(category.name.toLowerCase()) > -1)
      ) {
        matchedCategories.push(category);
      }
    }

    if (matchedCategories.length == 0) {
      matchedCategories = flattenedCategories.slice(0, 12);
    }

    return matchedCategories.slice(0, 12);
  };

  getRelatedSearches = () => {
    var query = (this.state.lastQuery || "").replace(/\s+/g, " ").trim();
    if (!query) {
      return [];
    }
	
	if ( query.indexOf('polovno') > -1 || query.indexOf('cijena') > -1 || query.indexOf('prodaja') > -1 ) {
		return [];
	}

    var words = query.split(" ").filter(Boolean);
    var suggestions = [];

    suggestions.push(query + " cijena");
    suggestions.push(query + " prodaja");
    suggestions.push("polovno " + query);

    if (words.length > 1) {
      suggestions.push(words.slice(0, words.length - 1).join(" "));
      suggestions.push(words[0]);
    }

    var uniqueSuggestions = [];
    for (var suggestion of suggestions) {
      if (suggestion && uniqueSuggestions.indexOf(suggestion) < 0 && suggestion !== query) {
        uniqueSuggestions.push(suggestion);
      }
    }

    return uniqueSuggestions.slice(0, 6);
  };

  getSeoInfo = () => {
    var categoryPath = this.getCategoryPath();
    var baseUrl = window.location.origin.replace("://www.", "://");
    var path = window.location.pathname;
    var currentLanguage = this.props.currentLanguage || "ba";

    if (categoryPath.nowPath) {
      var categoryTerm = this.cleanSeoText(
        [categoryPath.nowPath2, categoryPath.nowPath].filter(Boolean).join(" " )
      );
      categoryTerm = Util.firstLettersUppercase(categoryTerm);
      var canonicalPath = "/k/" + categoryPath.nowPath + (categoryPath.nowPath2 ? "/" + categoryPath.nowPath2 : "");
      if (this.props.getPathWithLanguage) {
        canonicalPath = this.props.getPathWithLanguage(canonicalPath, currentLanguage);
      }

      return {
        title: categoryTerm + " - oglasi, cijene i prodaja | OPK.ba",
        description:
          "Pogledajte nove i polovne " +
          categoryTerm.toLowerCase() +
          " oglase na OPK.ba. Uporedite cijene, lokacije i prodavce u Bosni i Hercegovini.",
        canonical: baseUrl + canonicalPath,
        robots: "index, follow",
        listName: categoryTerm
      };
    }

    var params = new URLSearchParams(window ? window.location.search : {});
    var queryTerm = this.cleanSeoText(params.get("q"));
    if (queryTerm) {
      var searchPath = "/pretraga?q=" + encodeURIComponent(queryTerm);
      if (this.props.getPathWithLanguage) {
        searchPath = this.props.getPathWithLanguage("/pretraga", currentLanguage) + "?q=" + encodeURIComponent(queryTerm);
      }

      return {
        title: Util.firstLettersUppercase(queryTerm) + " - oglasi i cijene | OPK.ba",
        description:
          "Rezultati pretrage za " +
          queryTerm +
          " na OPK.ba. Pregledajte aktuelne oglase, cijene, lokacije i prodavce u Bosni i Hercegovini.",
        canonical: baseUrl + searchPath,
        robots: "index, follow",
        listName: queryTerm
      };
    }

    var canonicalPath = this.props.getPathWithLanguage
      ? this.props.getPathWithLanguage("/pretraga", currentLanguage)
      : path;

    return {
      title: "Pretraga oglasa | OPK.ba",
      description: "Pretražite aktuelne oglase za kupovinu i prodaju na OPK.ba.",
      canonical: baseUrl + canonicalPath,
      robots: "noindex, follow",
      listName: "Pretraga oglasa"
    };
  };

  getItemListJsonLd = (seoInfo) => {
    if (!this.state.itemsList || this.state.itemsList.length == 0) {
      return "";
    }

    var currentLanguage = this.props.currentLanguage || "ba";
    var baseUrl = window.location.origin.replace("://www.", "://");
    var items = this.state.itemsList.slice(0, 12).map((product, i) => {
      var productPath = "/p/" + product.link;
      if (this.props.getPathWithLanguage) {
        productPath = this.props.getPathWithLanguage(productPath, currentLanguage);
      }

      var item = {
        "@type": "ListItem",
        "position": i + 1,
        "url": baseUrl + productPath,
        "name": product.name
      };

      if (product.image) {
        item.image = product.image;
      }

      return item;
    });

    return JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ItemList",
      "name": seoInfo.listName + " - OPK.ba",
      "itemListElement": items
    });
  };

  refreshPageSearch = () => {
    var categoryPath = this.getCategoryPath();
    var nowPath = categoryPath.nowPath;
    var nowPathSave = nowPath;
    var nowPath2 = categoryPath.nowPath2;
    var nowPath0 = categoryPath.nowPath0;
    if (nowPath0 == "k") {
      nowPath = nowPath.replace(/-/g, " ");
      nowPath2 = nowPath2.replace(/-/g, " ");
    }

    var mainThis = this;
    if (nowPath) {
      if (this.state.firstRun) {
        var ret = Util.storagePreload(
          [
            "category_" + nowPath + "_" + nowPath2,
            "categoryf_" + nowPath + "_" + nowPath2,
            "categoryf2_" + nowPath + "_" + nowPath2,
          ],
          "json",
          [],
          false
        );
        this.setState({
          itemsList: ret["category_" + nowPath + "_" + nowPath2],
          promoted_products: ret["category_" + nowPath + "_" + nowPath2],
        });

        var savedList = localStorage.getItem(
          "category_" + nowPath + "_" + nowPath2
        );
        if (savedList) {
          savedList = JSON.parse(savedList);
        }
        if (savedList) {
          this.setState({
            lastQuery: nowPath + " " + nowPath2,
            itemsList: savedList,
          });
          document.title =
            Util.firstLettersUppercase(decodeURI(nowPath2 + " " + nowPath)) +
            " na OPK.ba";
        }
      }
      this.setState({ loadingSearch: true });
      var oldFilters = [this.state.filter, this.state.filterCheck];

      apiWithLanguage
        .getCategoryData({
          category: decodeURI(nowPathSave),
          filter: nowPath2,
          customFilter: this.state.filterSearch,
          mainCategory: this.state.mainCategory,
          oldFilters: oldFilters,
          sort_value: this.state.sortValue,
        })
        .then((res) => {
          var loadedProducts = res["data"]["responseData"]["products"];
          mainThis.setState({
            firstRun: false,
            loadingSearch: false,
            lastQuery: nowPath + " " + nowPath2,
            itemsList: loadedProducts,
            filter: res["data"]["responseData"]["filter"],
            filterCheck: res["data"]["responseData"]["filtercheck"],
            mainCategory: res["data"]["responseData"]["mainCategory"],
            promoted_products: res["data"]["responseData"]["promoted_products"],
            popularProducts: res["data"]["responseData"]["popular_products"] || [],
          });

          if (nowPath2 && loadedProducts.length <= 6) {
            mainThis.loadBroaderCategoryProducts(nowPathSave);
          } else {
            mainThis.setState({ broaderProducts: [] });
          }

          document.title =
            Util.firstLettersUppercase(decodeURI(nowPath2 + " " + nowPath)) +
            " na OPK.ba";

          localStorage.setItem(
            "category_" + nowPath + "_" + nowPath2,
            JSON.stringify(res["data"]["responseData"]["products"])
          );
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      var params = new URLSearchParams(window ? window.location.search : {});
      var queryTerm = this.cleanSeoText(params.get("q"));
      this.setState({ loadingSearch: true });
      apiWithLanguage
        .searchProducts({
          loc: params.get("l"),
          filter: queryTerm,
          customFilter: this.state.filterSearch,
          mainCategory: this.state.mainCategory,
          oldFilters: [this.state.filter, this.state.filterCheck],
          sort_value: this.state.sortValue,
        })
        .then((res) => {
          document.title = queryTerm
            ? Util.firstLettersUppercase(queryTerm) + " - OPK.ba"
            : "Pretraga oglasa - OPK.ba";
          mainThis.setState({
            firstRun: false,
            loadingSearch: false,
            lastQuery: queryTerm,
            itemsList: res["data"]["responseData"]["products"],
            filter: res["data"]["responseData"]["filter"],
            filterCheck: res["data"]["responseData"]["filtercheck"],
            mainCategory: res["data"]["responseData"]["mainCategory"],
            topStores: res["data"]["responseData"]["topstores"],
            lastSearch: window.location.search,
            broaderProducts: [],
            popularProducts: [],
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  updateCustomFilter = (val, callback) => {
    if (callback) {
      this.setState(val, callback);
    } else {
      this.setState(val);
    }
  };

  resetFilters = () => {
    this.setState(
      {
        filterSearch: [],
        filter: [],
        filterCheck: [],
        lastQuery: "",
        firstRun: true,
      },
      () => {
        this.refreshPageSearch();
      }
    );
  };

  updateDone = () => {
    var filterQuery = [];
    for (var itemf of this.state.filter) {
      if (itemf["fromto"]) {
        if (itemf["value"] && !itemf["value1"]) {
          filterQuery.push({
            title: itemf["id"],
            option: [{ val: itemf["value"], dir: "min" }],
          });
        } else if (!itemf["value"] && itemf["value1"]) {
          filterQuery.push({
            title: itemf["id"],
            option: [{ val: itemf["value1"], dir: "max" }],
          });
        } else if (itemf["value"] && itemf["value1"]) {
          filterQuery.push({
            title: itemf["id"],
            option: [
              { val: itemf["value"], val1: itemf["value1"], dir: "both" },
            ],
          });
        }
      } else if (itemf["value"]) {
        filterQuery.push({ title: itemf["id"], option: [itemf["value"]] });
      }
    }

    var otherList = [];
    for (itemf of this.state.filterCheck) {
      if (itemf["checked"]) {
        otherList.push(itemf["id"]);
      }
    }

    if (otherList.length > 0) {
      filterQuery.push({ title: "Ostalo", option: otherList });
    }

    this.setState({ filterSearch: filterQuery }, () => {
      this.refreshPageSearch();
    });
  };

  showFilters = () => {
    this.setState({ dropFilters: !this.state.dropFilters });
  };

  sortBy = (sortValue) => {
    this.setState({ sortValue: sortValue }, () => {
      this.refreshPageSearch();
    });
  };

  renderSeoIntro = (seoInfo) => {
    var categoryPath = this.getCategoryPath();

    if (categoryPath.nowPath) {
      return (
        <div className="search_landing_box">
          <h1>{seoInfo.listName}</h1>
          <p>{seoInfo.description}</p>
        </div>
      );
    }

    if (this.state.lastQuery) {
      return (
        <div className="search_landing_box">
          <h1>{this.t("Pretraga za")} {Util.firstLettersUppercase(this.state.lastQuery)}</h1>
          <p>{this.t("Pregledajte oglase, cijene, lokacije i prodavce za unesenu pretragu.")}</p>
        </div>
      );
    }

    return null;
  };

  renderCategoryLinks = (title, links) => {
    if (!links || links.length == 0) {
      return null;
    }

    return (
      <div className="search_related_box">
        <h2>{title}</h2>
        <div className="search_related_links">
          {links.map((oneItem, i) => (
            <Link to={this.path(oneItem.link)} key={i}>
              {Util.firstLettersUppercase(oneItem.name)}
            </Link>
          ))}
        </div>
      </div>
    );
  };

  renderSearchLinks = (title, links) => {
    if (!links || links.length == 0) {
      return null;
    }

    return (
      <div className="search_related_box">
        <h2>{title}</h2>
        <div className="search_related_links">
          {links.map((oneItem, i) => (
            <Link
              to={this.path("/pretraga") + "?q=" + encodeURIComponent(oneItem)}
              key={i}
            >
              {Util.firstLettersUppercase(oneItem)}
            </Link>
          ))}
        </div>
      </div>
    );
  };

  renderProductStrip = (title, products, limit) => {
    if (!products || products.length == 0) {
      return null;
    }

    return (
      <div className="search_products_strip">
        <h2>{title}</h2>
        <div className="search_products_strip_items">
          {products.slice(0, limit || 8).map((oneItem, i) => (
            <div className="search_products_strip_item" key={i}>
              <Link to={this.path("/p/" + oneItem.link)}>
                <div
                  className="search_products_strip_image"
                  style={{
                    backgroundImage: oneItem.image ? "url(" + oneItem.image + ")" : "",
                  }}
                ></div>
                <div className="search_products_strip_name">{oneItem.name}</div>
                <div className="search_products_strip_price">
                  {Util.formatPrice(oneItem.price)}
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    );
  };

  renderLandingBlocks = (seoInfo) => {
    var categoryPath = this.getCategoryPath();
    var hasProducts = this.state.itemsList && this.state.itemsList.length > 0;
    var fewProducts = hasProducts && this.state.itemsList.length <= 6;

    if (categoryPath.nowPath) {
      return (
        <>
          {this.renderSeoIntro(seoInfo)}
          {this.renderCategoryLinks(this.t("Povezane kategorije"), this.getCategoryLandingLinks())}
          {this.renderProductStrip(this.t("Popularno u ovoj kategoriji"), this.state.popularProducts)}
          {this.renderProductStrip(this.t("Najnoviji oglasi"), this.state.itemsList)}
          {fewProducts &&
            this.renderProductStrip(
              this.t("Slični oglasi iz šire kategorije"),
              this.state.broaderProducts
            )}
        </>
      );
    }

    if (this.state.lastQuery) {
      return (
        <>
          {this.renderSeoIntro(seoInfo)}
          {hasProducts && this.renderSearchLinks(this.t("Povezane pretrage"), this.getRelatedSearches())}
          {hasProducts && this.renderCategoryLinks(this.t("Kategorije za nastavak pretrage"), this.getSearchCategoryLinks())}
          {fewProducts && this.renderProductStrip(this.t("Slični oglasi"), this.state.recentProducts)}
          {!hasProducts && this.renderSearchLinks(this.t("Pokušajte drugačiju pretragu"), this.getRelatedSearches())}
          {!hasProducts && this.renderCategoryLinks(this.t("Popularne kategorije"), this.getSearchCategoryLinks())}
        </>
      );
    }

    return null;
  };



  renderSearchResultProducts = () => {
    if (!this.state.lastQuery) {
      return null;
    }

    var hasProducts = this.state.itemsList && this.state.itemsList.length > 0;
    return this.renderProductStrip(
      this.t("Najnoviji oglasi"),
      this.state.recentProducts,
      hasProducts ? 20 : 30
    );
  };

  render() {
    var seoInfo = this.getSeoInfo();
    var itemListJsonLd = this.getItemListJsonLd(seoInfo);

    return (
      <div className="search_page">
        <SEOHead
          title={seoInfo.title}
          description={seoInfo.description}
          canonical={seoInfo.canonical}
          robots={seoInfo.robots}
        />
        {itemListJsonLd && (
          <script type="application/ld+json">{itemListJsonLd}</script>
        )}
        <div className="see_filters_button" onClick={this.showFilters}>
          {this.state.dropFilters
            ? this.t("Prikaži sve filtere")
            : this.t("Sakrij sve filtere")}
        </div>
        <div
          className={
            "page_1of4" +
            (this.state.dropFilters ? " search_page_hide_1of4" : "")
          }
        >
          {this.state.filterSearch.length !== 0 && (
            <div className="filter_list_item">
              <div className="reset_btn" onClick={this.resetFilters}>
                {this.t("Resetuj")}
              </div>
            </div>
          )}
          {(this.state.filter.length > 0 || this.state.filterCheck.length > 0) && (
            <div className="filter_intro">
              {this.t("Filteri za cijenu, stanje, preuzimanje i dodatne karakteristike")}
            </div>
          )}
          <CustomFilter
            currentList={this.state.filter}
            checkbox={false}
            updateCustomFilter={this.updateCustomFilter}
            callback={this.updateDone}
          />
          <CustomFilter
            currentList={this.state.filterCheck}
            checkbox={true}
            updateCustomFilter={this.updateCustomFilter}
            callback={this.updateDone}
          />
        </div>
        {!this.state.dropFilters && (
          <div className="see_filters_button" onClick={this.showFilters}>
            {this.t("Sakrij sve filtere")}
          </div>
        )}
        <div className="page_3of4">
          {!this.state.loadingSearch && this.renderLandingBlocks(seoInfo)}
          {!this.state.loadingSearch && (
            <Results
              promotedList={this.state.promoted_products}
              lastSearch={this.state.lastQuery}
              storesList={this.state.topStores}
              productsList={this.state.itemsList}
              sortMenu={this.sortMenu}
              sortMenuOpen={this.state.sortMenuOpen}
              sortValue={this.state.sortValue}
              sortBy={this.sortBy}
              currentLanguage={this.props.currentLanguage}
              getPathWithLanguage={this.props.getPathWithLanguage}
              isMyProfile={false}
              noResultsText={this.t("Nema pronadjenih proizvoda")}
            />
          )}
          {!this.state.loadingSearch && this.renderSearchResultProducts()}
        </div>
        <div
          className={
            "loader_holder" + (this.state.loadingSearch ? " active" : "")
          }
        >
          <div className="loader_big"></div>
        </div>
      </div>
    );
  }
}

// Wrap with data translation HOC
const SearchWithTranslation = withDataTranslation(Search);

export default SearchWithTranslation;
